// packages/web/src/components/ThresholdStepper.tsx
interface ThresholdStepperProps {
  value: number;
  onChange: (value: number) => void;
  min: number;
  max: number;
  label: string;
  description?: string;
}

export function ThresholdStepper({ value, onChange, min, max, label, description }: ThresholdStepperProps) {
  return (
    <div className="flex items-center justify-between gap-4">
      <div>
        <p className="text-sm font-medium text-stone-800 dark:text-stone-100">{label}</p>
        {description && <p className="text-xs text-stone-500 dark:text-stone-400 mt-0.5">{description}</p>}
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        <button
          aria-label="Decrease threshold"
          onClick={() => onChange(Math.max(min, value - 1))}
          disabled={value <= min}
          className="w-7 h-7 flex items-center justify-center rounded border border-stone-300 dark:border-gray-600 text-stone-700 dark:text-stone-200 hover:bg-stone-100 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed font-medium"
        >
          −
        </button>
        <span className="text-sm font-semibold text-stone-800 dark:text-stone-100 min-w-[48px] text-center">
          {value}/{max}
        </span>
        <button
          aria-label="Increase threshold"
          onClick={() => onChange(Math.min(max, value + 1))}
          disabled={value >= max}
          className="w-7 h-7 flex items-center justify-center rounded border border-stone-300 dark:border-gray-600 text-stone-700 dark:text-stone-200 hover:bg-stone-100 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed font-medium"
        >
          +
        </button>
      </div>
    </div>
  );
}
